__turbopack_context__.v({
  "tabHeader": "accordion-tab-mobile-module-scss-module__XSvrNa__tabHeader",
  "tabHeaderIcon": "accordion-tab-mobile-module-scss-module__XSvrNa__tabHeaderIcon",
  "title": "accordion-tab-mobile-module-scss-module__XSvrNa__title",
});
